import { render, staticRenderFns } from "./AddImageChick.vue?vue&type=template&id=7f5c0466"
import script from "./AddImageChick.vue?vue&type=script&lang=js"
export * from "./AddImageChick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports